import {
    DataGridProps,
    GridValidRowModel,
    DataGrid as MuiDataGrid,
} from "@mui/x-data-grid";
import CustomNoRowsOverlay from "./components/CustomNoROwsOverlay/indext";

const DataGrid = <T extends GridValidRowModel>(options: DataGridProps<T>) => {
    return (
        <MuiDataGrid<T>
            pageSizeOptions={[]}
            isRowSelectable={() => false}
            hideFooterSelectedRowCount
            hideFooterPagination
            slots={{ noRowsOverlay: CustomNoRowsOverlay }}
            sx={{
                "& .MuiDataGrid-row.row--removed": {
                    backgroundColor: (theme) => theme.palette.error.main,
                },
                "& .MuiDataGrid-row.row--edited": {
                    backgroundColor: (theme) => theme.palette.warning.light,
                },
                "& .success": {
                    backgroundColor: (theme) => theme.palette.primary.light,
                },
                "& .success:hover": {
                    backgroundColor: (theme) => theme.palette.primary.main,
                },
                "& .warning": {
                    backgroundColor: (theme) => theme.palette.warning.light,
                },
                "& .warning:hover": {
                    backgroundColor: (theme) => theme.palette.warning.main,
                },
                "& .fail": {
                    backgroundColor: (theme) => theme.palette.error.main,
                },
                "& .fail:hover": {
                    backgroundColor: (theme) => theme.palette.error.dark,
                },
            }}
            {...options}
        />
    );
};

export default DataGrid;
